module.exports = __webpack_public_path__ + "img/1.f56eee60.png";